import { render } from "./BadgeEdit.vue?vue&type=template&id=f07dfefa&ts=true"
import script from "./BadgeEdit.ts?vue&type=script&lang=ts"
export * from "./BadgeEdit.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__